export function formatDemandCode(id) {
  if (id == null) return '-'
  return `D${String(id).padStart(3, '0')}`
}

export function formatBudget(value) {
  const num = Number(value || 0)
  return `¥${num.toLocaleString('zh-CN', { maximumFractionDigits: 0 })}`
}

export function formatDemandAmount(value) {
  const num = Number(value || 0)
  if (num >= 10000) {
    return `¥${(num / 10000).toFixed(1)}万`
  }
  return formatBudget(num)
}

export function demandStatusTagType(status) {
  if (status === 0) return 'warning'
  if (status === 1) return ''
  if (status === 2) return 'primary'
  if (status === 3) return 'success'
  if (status === 4) return 'danger'
  return 'info'
}
